function termsAndCondition() {
    if (window.__termsAndConditionInitialized) return;
    window.__termsAndConditionInitialized = true;

    function getTermsScope(element) {
        var cartDetails = element.closest('#AjaxCartSubtotal .cart__details');
        if (cartDetails) return cartDetails;

        var newsletter = element.closest('.newsletter__container');
        if (newsletter) return newsletter;

        var form = element.closest('form');
        if (form && form.querySelector('.accept_privacy_policy')) return form;

        var customBox = element.closest('.custom-box');
        return customBox ? customBox.parentElement : null;
    }

    function updateSubmitState(scope) {
        var privacy = scope.querySelector('.accept_privacy_policy');
        var submitBtn = scope.querySelector('.toggle-button');
        if (!privacy || !submitBtn) return;

        if (privacy.checked) {
            submitBtn.classList.remove('disabled-button');
        } else {
            submitBtn.classList.add('disabled-button');
        }
    }

    document.addEventListener('change', function (e) {
        if (!e.target.matches('.accept_privacy_policy')) return;
        var scope = getTermsScope(e.target);
        if (scope) updateSubmitState(scope);
    });

    document.querySelectorAll('.accept_privacy_policy').forEach(function (privacy) {
        var scope = getTermsScope(privacy);
        if (scope) updateSubmitState(scope);
    });
}

termsAndCondition();


/**
 * Rebuy Product Add-Ons (without Smart Cart)
 *
 * Flow:
 * 1) Theme adds the main product and paints/opens the cart immediately
 * 2) If Product Add-Ons are selected, let Rebuy's native hook add them
 * 3) Only force-add when native hook did not run (avoid double-add → error toast)
 * 4) Silently refresh the drawer so add-ons appear (never auto-open on load)
 */
(function initRebuyCartSync() {
    if (window.__rebuyCartSyncInitialized) return;
    window.__rebuyCartSyncInitialized = true;

    var refreshTimer = null;
    var allowEventRefresh = false;
    var notificationHideTimer = null;

    function getWidgetsWithSelection() {
        if (!window.Rebuy || !Array.isArray(window.Rebuy.widgets)) return [];
        try {
            return window.Rebuy.widgets.filter(function (widget) {
                try {
                    return (
                        typeof widget.addSelectedProductsToCart === 'function' &&
                        typeof widget.selectedProductCount === 'function' &&
                        widget.selectedProductCount() > 0
                    );
                } catch (e) {
                    return false;
                }
            });
        } catch (e) {
            return [];
        }
    }

    function getSelectedAddonVariantIds(widgets) {
        var ids = [];
        (widgets || []).forEach(function (widget) {
            var products =
                (widget.data && widget.data.products) ||
                widget.products ||
                [];
            products.forEach(function (product) {
                var selected = true;
                try {
                    if (typeof widget.productIsSelected === 'function') {
                        selected = widget.productIsSelected(product);
                    }
                } catch (e) {
                    selected = true;
                }
                if (!selected) return;
                var variantId =
                    product.selected_variant_id ||
                    (product.selected_variant && product.selected_variant.id) ||
                    (product.variants && product.variants[0] && product.variants[0].id);
                if (variantId) ids.push(Number(variantId));
            });
        });
        return ids;
    }

    var REBUY_LINK_STORAGE_KEY = 'rebuy_addon_parent_links';

    function readAddonParentLinks() {
        try {
            return JSON.parse(sessionStorage.getItem(REBUY_LINK_STORAGE_KEY) || '{}');
        } catch (e) {
            return {};
        }
    }

    function writeAddonParentLinks(links) {
        try {
            sessionStorage.setItem(REBUY_LINK_STORAGE_KEY, JSON.stringify(links || {}));
        } catch (e) {}
    }

    /** Currently selected Product Add-On variant IDs (from Rebuy widgets). */
    window.getSelectedRebuyAddonVariantIds = function getSelectedRebuyAddonVariantIds() {
        return getSelectedAddonVariantIds(getWidgetsWithSelection());
    };

    /**
     * Remember which add-on variants belong to which parent variant.
     * Used so removing an unrelated product does not remove someone else's add-ons.
     */
    window.rememberRebuyAddonParents = function rememberRebuyAddonParents(parentVariantId, addonVariantIds) {
        var parentId = Number(parentVariantId);
        if (!parentId || !addonVariantIds || !addonVariantIds.length) return;

        var links = readAddonParentLinks();
        var key = String(parentId);
        var existing = Array.isArray(links[key]) ? links[key] : [];
        var merged = existing.slice();

        addonVariantIds.forEach(function (id) {
            var n = Number(id);
            if (n && merged.indexOf(n) === -1) merged.push(n);
        });

        links[key] = merged;
        writeAddonParentLinks(links);
    };

    /** Add-on variant IDs linked to a parent variant. */
    window.getRebuyAddonsForParent = function getRebuyAddonsForParent(parentVariantId) {
        var links = readAddonParentLinks();
        var list = links[String(Number(parentVariantId))];
        return Array.isArray(list) ? list.slice() : [];
    };

    window.clearRebuyAddonLinksForParent = function clearRebuyAddonLinksForParent(parentVariantId) {
        var links = readAddonParentLinks();
        delete links[String(Number(parentVariantId))];
        writeAddonParentLinks(links);
    };

    /** Drop an add-on variant from all parent link lists (when the add-on itself is removed). */
    window.unlinkRebuyAddonVariant = function unlinkRebuyAddonVariant(addonVariantId) {
        var addonId = Number(addonVariantId);
        if (!addonId) return;
        var links = readAddonParentLinks();
        Object.keys(links).forEach(function (parentKey) {
            links[parentKey] = (links[parentKey] || []).filter(function (id) {
                return Number(id) !== addonId;
            });
            if (!links[parentKey].length) delete links[parentKey];
        });
        writeAddonParentLinks(links);
    };

    function fetchCart() {
        var cartUrl =
            window.Shopify && Shopify.routes && Shopify.routes.root
                ? Shopify.routes.root + 'cart.js'
                : '/cart.js';
        return fetch(cartUrl).then(function (r) {
            return r.json();
        });
    }

    function selectedAddonsAlreadyInCart(widgets) {
        var selectedIds = getSelectedAddonVariantIds(widgets);
        if (!selectedIds.length) {
            return Promise.resolve(getWidgetsWithSelection().length === 0);
        }
        return fetchCart()
            .then(function (cart) {
                var inCart = {};
                (cart.items || []).forEach(function (item) {
                    inCart[Number(item.variant_id)] = true;
                });
                return selectedIds.every(function (id) {
                    return !!inCart[id];
                });
            })
            .catch(function () {
                return false;
            });
    }

    function hideRebuyErrorNotifications() {
        document
            .querySelectorAll(
                '.rebuy-notification, .rebuy-toast, .rebuy-cart-error, ' +
                '[class*="rebuy-notification"], [id*="rebuy-notification"], ' +
                '[class*="rebuy-toast"], .rebuy-widget .error, .rebuy-widget .alert, ' +
                '#AjaxCartForm .alert--error, #AjaxCartSubtotal .alert--error, ' +
                '#product-page-form-error-cart-alert, .sidebar .alert--error, ' +
                '[data-js-site-cart-sidebar] .alert--error, product-form .alert--error'
            )
            .forEach(function (el) {
                el.style.display = 'none';
                el.setAttribute('aria-hidden', 'true');
                try {
                    el.remove();
                } catch (e) {}
            });
    }

    // Strip error toasts as soon as Rebuy/theme injects them during ATC
    if (!window.__rebuyErrorObserver) {
        window.__rebuyErrorObserver = new MutationObserver(function () {
            if (
                !window.__rebuySuppressNotifications &&
                !document.body.classList.contains('rebuy-atc-suppress-errors')
            ) {
                return;
            }
            hideRebuyErrorNotifications();
        });
        try {
            window.__rebuyErrorObserver.observe(document.documentElement, {
                childList: true,
                subtree: true
            });
        } catch (e) {}
    }

    window.isRebuyAddonLineItem = function isRebuyAddonLineItem(item) {
        if (!item) return false;
        var props = item.properties || {};
        var source = props._source || props.source || '';
        var attribution = String(props._attribution || props.attribution || '').toLowerCase();
        return (
            source === 'Rebuy' ||
            attribution.indexOf('rebuy') !== -1 ||
            attribution.indexOf('add-on') !== -1 ||
            attribution.indexOf('addon') !== -1 ||
            attribution.indexOf('product add') !== -1
        );
    };

    window.hasRebuyProductAddOnsSelected = function hasRebuyProductAddOnsSelected() {
        return getWidgetsWithSelection().length > 0;
    };

    /**
     * Wait for Rebuy's native Product Add-Ons hook to finish, then resolve.
     * Never force-calls addSelectedProductsToCart — that double-adds and shows
     * inventory/error notifications even when items are already in the cart.
     */
    window.syncRebuyProductAddOns = function syncRebuyProductAddOns() {
        return new Promise(function (resolve) {
            var finished = false;
            var settleTimer = null;
            var pollTimer = null;
            var maxTimer = null;

            function cleanup() {
                document.removeEventListener('rebuy.add', onRebuyActivity);
                document.removeEventListener('rebuy:cart.add', onRebuyActivity);
                clearTimeout(settleTimer);
                clearTimeout(pollTimer);
                clearTimeout(maxTimer);
            }

            function done() {
                if (finished) return;
                finished = true;
                window.__rebuySyncInProgress = false;
                cleanup();
                hideRebuyErrorNotifications();
                clearTimeout(notificationHideTimer);
                notificationHideTimer = setTimeout(function () {
                    window.__rebuySuppressNotifications = false;
                    hideRebuyErrorNotifications();
                }, 1500);
                resolve();
            }

            function onRebuyActivity() {
                clearTimeout(settleTimer);
                settleTimer = setTimeout(done, 400);
            }

            try {
                var widgets = getWidgetsWithSelection();
                if (!widgets.length) {
                    resolve();
                    return;
                }

                window.__rebuySyncInProgress = true;
                window.__rebuySuppressNotifications = true;
                document.body.classList.add('rebuy-atc-suppress-errors');

                document.addEventListener('rebuy.add', onRebuyActivity);
                document.addEventListener('rebuy:cart.add', onRebuyActivity);

                // Poll until selected add-ons are in the cart (added by Rebuy's native hook)
                var polls = 0;
                function pollCart() {
                    if (finished) return;
                    polls += 1;
                    selectedAddonsAlreadyInCart(widgets).then(function (alreadyInCart) {
                        if (finished) return;
                        if (alreadyInCart || getWidgetsWithSelection().length === 0) {
                            onRebuyActivity();
                            return;
                        }
                        if (polls < 10) {
                            pollTimer = setTimeout(pollCart, 250);
                        }
                    });
                }
                pollTimer = setTimeout(pollCart, 300);

                maxTimer = setTimeout(done, 2500);
            } catch (e) {
                window.__rebuySyncInProgress = false;
                window.__rebuySuppressNotifications = false;
                resolve();
            }
        });
    };

    function scheduleSilentCartRefresh() {
        if (!allowEventRefresh || window.__rebuySyncInProgress) return;
        if (typeof window.refreshCart !== 'function') return;

        clearTimeout(refreshTimer);
        refreshTimer = setTimeout(function () {
            if (!allowEventRefresh || window.__rebuySyncInProgress) return;
            window.refreshCart({ open: false, preserveToken: true });
            hideRebuyErrorNotifications();
        }, 350);
    }

    document.addEventListener('add-to-cart', function () {
        allowEventRefresh = true;
    });

    document.addEventListener('rebuy.add', scheduleSilentCartRefresh);
    document.addEventListener('rebuy:cart.add', scheduleSilentCartRefresh);

    // Always hide Rebuy error notifications (user request: never show after ATC)
    document.addEventListener('rebuy:notification.show', function (event) {
        try {
            if (event && typeof event.preventDefault === 'function') event.preventDefault();
            if (event && typeof event.stopImmediatePropagation === 'function') event.stopImmediatePropagation();
        } catch (e) {}
        hideRebuyErrorNotifications();
        setTimeout(hideRebuyErrorNotifications, 0);
        setTimeout(hideRebuyErrorNotifications, 50);
        setTimeout(hideRebuyErrorNotifications, 200);
        setTimeout(hideRebuyErrorNotifications, 500);
    }, true);
})();

document.addEventListener('DOMContentLoaded', function() {
    const searchButton = document.querySelector('button[opensearch="true"]');
    const searchInput = document.querySelector('.mobile-search');
    if (searchButton) {
        searchButton.addEventListener('click', function() {
            if (window.innerWidth < 1024) { 
                if (searchInput.style.display === 'none') {
                    searchInput.style.display = 'block';
                } else {
                    searchInput.style.display = 'none';
                }
            }
        });
    }
});

document.addEventListener('DOMContentLoaded', function() {
    const acceptPrivacyPolicyContact = document.querySelector('#accept_privacy_policy_contact');
    const contactButton = document.querySelector('.contact-button');
    if (!acceptPrivacyPolicyContact) return;
    acceptPrivacyPolicyContact.addEventListener('change', function() {
        if (acceptPrivacyPolicyContact.checked) {
            contactButton.querySelector('button').classList.remove('disabled-button');
        } else {
            contactButton.querySelector('button').classList.add('disabled-button');
        }
    });
});

function initProductAdultVerificationPopup() {
    var overlay = document.getElementById('age-confirm-overlay');
    if (!overlay) return;

    var productId = overlay.getAttribute('data-product-id');
    if (!productId) return;

    var storageKey = 'age_ok_' + productId;

    try {
        if (sessionStorage.getItem(storageKey) === '1') return;
    } catch (e) {}

    var btnOk = document.getElementById('age-confirm-btn-ok');
    var btnCancel = document.getElementById('age-confirm-btn-cancel');

    function showPopup() {
        overlay.style.display = 'flex';
        document.body.classList.add('age-confirm-open');
        setTimeout(function () {
            var firstBtn = overlay.querySelector('button');
            if (firstBtn) firstBtn.focus();
        }, 50);
    }

    function hidePopup() {
        overlay.style.display = 'none';
        document.body.classList.remove('age-confirm-open');
    }

    function goBack() {
        if (window.history.length > 1) {
            window.history.back();
        } else {
            window.location.href = '/';
        }
    }

    function isVisible() {
        return overlay.style.display !== 'none';
    }

    function trapFocus() {
        overlay.addEventListener('keydown', function (e) {
            if (e.key !== 'Tab') return;
            var focusable = overlay.querySelectorAll(
                'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
            );
            if (!focusable.length) return;
            var first = focusable[0];
            var last = focusable[focusable.length - 1];
            if (e.shiftKey) {
                if (document.activeElement === first) {
                    e.preventDefault();
                    last.focus();
                }
            } else if (document.activeElement === last) {
                e.preventDefault();
                first.focus();
            }
        });
    }

    showPopup();

    if (btnOk) {
        btnOk.addEventListener('click', function () {
            try {
                sessionStorage.setItem(storageKey, '1');
            } catch (e) {}
            hidePopup();
        });
    }

    if (btnCancel) {
        btnCancel.addEventListener('click', goBack);
    }

    overlay.addEventListener('click', function (e) {
        if (e.target === overlay) goBack();
    });

    document.addEventListener('keydown', function (e) {
        if ((e.key === 'Escape' || e.keyCode === 27) && isVisible()) goBack();
    });

    trapFocus();
}

document.addEventListener('DOMContentLoaded', initProductAdultVerificationPopup);

document.addEventListener('DOMContentLoaded', function () {
    const interval = setInterval(() => {
        const whatsappButton = document.querySelector('.whatsapp-button');
        const whatsapp = document.querySelector('#whatsapp-link');
        if (!whatsappButton) {
            clearInterval(interval);
            return;
        }

        if (whatsapp) {
            clearInterval(interval);

            whatsappButton.addEventListener('click', function () {
                whatsapp.click();
            });
        }
    }, 100);
});

/**
 * Localize Rebuy Product Add-Ons copy so the widget matches the Polish PDP.
 * Prefer patching widget config (Vue-reactive) and fall back to DOM text.
 */
(function initRebuyAddonLocalization() {
    if (window.__rebuyAddonLocalizationInitialized) return;
    window.__rebuyAddonLocalizationInitialized = true;

    var LEARN_MORE_PL = 'Dowiedz się więcej';
    var debounceTimer = null;

    function patchWidgetLanguage() {
        if (!window.Rebuy || !Array.isArray(window.Rebuy.widgets)) return;
        window.Rebuy.widgets.forEach(function (widget) {
            try {
                var lang = widget.config && widget.config.language;
                if (!lang) return;
                var label = lang.learn_more_label;
                if (typeof label === 'string' && /learn\s*more/i.test(label.trim())) {
                    lang.learn_more_label = LEARN_MORE_PL;
                }
            } catch (e) {}
        });
    }

    function patchDomLabels() {
        document.querySelectorAll('.rebuy-addon__item-learn-more-link').forEach(function (link) {
            var text = (link.textContent || '').trim();
            if (/learn\s*more/i.test(text)) {
                link.textContent = LEARN_MORE_PL;
            }
        });
    }

    function localize() {
        patchWidgetLanguage();
        patchDomLabels();
    }

    function scheduleLocalize() {
        clearTimeout(debounceTimer);
        debounceTimer = setTimeout(localize, 100);
    }

    localize();
    document.addEventListener('rebuy.ready', localize);
    document.addEventListener('rebuy:ready', localize);
    document.addEventListener('rebuy.widgets.loaded', localize);

    if (!window.__rebuyLearnMoreObserver) {
        window.__rebuyLearnMoreObserver = new MutationObserver(function (mutations) {
            for (var i = 0; i < mutations.length; i++) {
                var nodes = mutations[i].addedNodes;
                for (var j = 0; j < nodes.length; j++) {
                    var node = nodes[j];
                    if (node.nodeType !== 1) continue;
                    if (
                        (node.matches && node.matches('.rebuy-widget, .rebuy-addon, .rebuy-addon__item-learn-more-link')) ||
                        (node.querySelector && node.querySelector('.rebuy-addon__item-learn-more-link, .rebuy-addon'))
                    ) {
                        scheduleLocalize();
                        return;
                    }
                }
            }
        });
        window.__rebuyLearnMoreObserver.observe(document.body, {
            childList: true,
            subtree: true
        });
    }

    // Rebuy often hydrates after first paint
    setTimeout(localize, 500);
    setTimeout(localize, 1500);
    setTimeout(localize, 3000);
})();

/**
 * Rebuy Smart Cart bridge
 * - Hide theme drawer (#site-cart-sidebar) when Smart Cart is enabled
 * - Cart icon / ATC "open drawer" → Rebuy.SmartCart.show()
 * Safe no-op when Smart Cart is off (keeps theme cart).
 *
 * Important: must NOT call theme drawer.hide()/show() in a cart.change loop —
 * that freezes the storefront during Smart Cart preview (viewcart=true).
 */
(function initRebuySmartCartBridge() {
    if (window.__rebuySmartCartBridgeInitialized) return;
    window.__rebuySmartCartBridgeInitialized = true;

    var unlocking = false;
    var unlockTimer = null;

    function isSmartCartEnabled() {
        return !!(
            document.body &&
            (document.body.classList.contains('smart-cart--enabled') ||
                document.documentElement.classList.contains('smart-cart--enabled'))
        );
    }

    function showSmartCart() {
        try {
            if (window.Rebuy && Rebuy.SmartCart && typeof Rebuy.SmartCart.show === 'function') {
                Rebuy.SmartCart.show();
                return true;
            }
        } catch (e) {}
        return false;
    }

    function clearThemeInertLocks() {
        try {
            if (window.inertElems && window.inertElems.length) {
                window.inertElems.forEach(function (elm) {
                    if (elm && elm.removeAttribute) elm.removeAttribute('inert');
                });
            }
        } catch (e) {}
        document.querySelectorAll('[inert]').forEach(function (elm) {
            // Keep inert inside Rebuy Smart Cart UI if present
            if (elm.closest && elm.closest('#rebuy-cart, .rebuy-cart, [data-rebuy-cart], .rebuy-modal')) {
                return;
            }
            elm.removeAttribute('inert');
        });
    }

    /**
     * Soft unlock only — never call drawer.hide()/show() here.
     * Theme hide() is async (501ms) and fights Rebuy when preview auto-opens the cart.
     */
    function unlockThemeChrome() {
        if (unlocking) return;
        unlocking = true;
        try {
            var drawer = document.getElementById('site-cart-sidebar');
            if (drawer) {
                drawer.opened = false;
                drawer.classList.remove('sidebar--opened');
                drawer.style.setProperty('display', 'none', 'important');
                drawer.setAttribute('aria-hidden', 'true');
            }
            if (document.body) {
                document.body.classList.remove(
                    'sidebar-opened',
                    'sidebar-opened--right',
                    'sidebar-opened--left'
                );
            }
            var overlay = document.querySelector('.site-overlay');
            if (overlay) {
                overlay.style.setProperty('display', 'none', 'important');
                overlay.style.setProperty('pointer-events', 'none', 'important');
                overlay.style.setProperty('opacity', '0', 'important');
                overlay.style.setProperty('visibility', 'hidden', 'important');
            }
            clearThemeInertLocks();
        } finally {
            unlocking = false;
        }
    }

    function scheduleUnlock() {
        if (!isSmartCartEnabled()) return;
        unlockThemeChrome();
        clearTimeout(unlockTimer);
        // Cover theme show() 15ms inert + hide() 501ms display race
        unlockTimer = setTimeout(function () {
            if (isSmartCartEnabled()) unlockThemeChrome();
        }, 80);
        setTimeout(function () {
            if (isSmartCartEnabled()) unlockThemeChrome();
        }, 550);
    }

    function patchCartSidebarShow() {
        var drawer = document.getElementById('site-cart-sidebar');
        if (!drawer || typeof drawer.show !== 'function' || drawer.__rebuySmartCartPatched) {
            return;
        }
        drawer.__rebuySmartCartPatched = true;
        var originalShow = drawer.show.bind(drawer);
        drawer.show = function () {
            if (isSmartCartEnabled()) {
                scheduleUnlock();
                showSmartCart();
                return;
            }
            return originalShow();
        };
    }

    function isCartTrigger(el) {
        if (!el || !el.closest) return null;
        // Never intercept clicks inside Rebuy UI
        if (el.closest('#rebuy-cart, .rebuy-cart, [data-rebuy-cart], .rebuy-modal, .rebuy-widget')) {
            return null;
        }
        return (
            el.closest(
                '[aria-controls="site-cart-sidebar"], .header-icon-button--cart, .mobile-cart-button'
            ) || null
        );
    }

    function onCartTriggerClick(e) {
        if (!isSmartCartEnabled()) return;
        var trigger = isCartTrigger(e.target);
        if (!trigger) return;

        e.preventDefault();
        e.stopPropagation();
        if (typeof e.stopImmediatePropagation === 'function') {
            e.stopImmediatePropagation();
        }
        scheduleUnlock();
        showSmartCart();
    }

    document.addEventListener('click', onCartTriggerClick, true);

    function boot() {
        patchCartSidebarShow();
        if (isSmartCartEnabled()) scheduleUnlock();
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', boot);
    } else {
        boot();
    }

    document.addEventListener('rebuy.ready', boot);
    document.addEventListener('rebuy:ready', boot);
    document.addEventListener('rebuy:smartcart.ready', function () {
        boot();
        scheduleUnlock();
    });
    document.addEventListener('rebuy:smartcart.show', scheduleUnlock);
    document.addEventListener('rebuy:smartcart.hide', scheduleUnlock);

    /**
     * Keep Tiered Progress Bar at the top of Smart Cart (under title),
     * even if the Rebuy layout places it in body/footer.
     */
    var pinningBar = false;
    function pinProgressBarToTop() {
        if (pinningBar) return;
        try {
            var flyout = document.querySelector('#rebuy-cart .rebuy-cart__flyout, .rebuy-cart.is-visible .rebuy-cart__flyout');
            if (!flyout) return;
            var bar =
                flyout.querySelector('[data-rebuy-component="progress-bar"]') ||
                flyout.querySelector('.rebuy-cart__progress-bar-container');
            if (!bar) return;

            var header = flyout.querySelector('[data-rebuy-cart-anchor="header"]');
            var goalBox = flyout.querySelector('[data-rebuy-cart-anchor="goalBox"]');
            var alreadyTop =
                (goalBox && bar.parentElement === goalBox) ||
                (header && header.nextElementSibling === bar);

            if (alreadyTop) {
                if (goalBox) goalBox.style.display = '';
                applyLinearProgressFill(bar);
                return;
            }

            pinningBar = true;
            if (goalBox) {
                goalBox.style.display = '';
                goalBox.insertBefore(bar, goalBox.firstChild);
            } else if (header) {
                header.after(bar);
            } else if (flyout.firstElementChild !== bar) {
                flyout.insertBefore(bar, flyout.firstChild);
            }
            applyLinearProgressFill(bar);
        } catch (e) {
        } finally {
            pinningBar = false;
        }
    }

    /**
     * Rebuy fills the meter in equal per-tier segments (e.g. 250/277 → ~45%).
     * Override to linear fill vs the final tier (e.g. 250/377 → ~66%).
     * Unlock thresholds stay Rebuy's; this is visual only.
     */
    var progressSubtotal = null;
    var applyingLinearFill = false;
    var DEFAULT_MAX_TIER = 377;

    function parseTierMinimums(bar) {
        var mins = [];
        if (!bar) return mins;
        bar.querySelectorAll('.rebuy-cart__progress-step-label').forEach(function (el) {
            var text = (el.textContent || '').replace(/\u00a0/g, ' ');
            var match = text.match(/(\d+(?:[.,]\d+)?)\s*zł/i);
            if (!match) return;
            var value = parseFloat(match[1].replace(',', '.'));
            if (!isNaN(value) && value > 0) mins.push(value);
        });
        mins.sort(function (a, b) {
            return a - b;
        });
        return mins;
    }

    function readVisibleCartSubtotal() {
        var flyout = document.querySelector('#rebuy-cart .rebuy-cart__flyout, .rebuy-cart__flyout');
        if (!flyout) return null;
        var nodes = flyout.querySelectorAll(
            '.rebuy-cart__progress-bar-prompt, [data-rebuy-cart-anchor="footer"] .rebuy-cart__flyout-subtotal, .rebuy-cart__flyout-subtotal'
        );
        var best = null;
        nodes.forEach(function (el) {
            var text = (el.textContent || '').replace(/\u00a0/g, ' ');
            // Prefer explicit money in subtotal area; skip "Brakuje Ci X zł" remaining amounts
            if (/brakuje/i.test(text)) return;
            var matches = text.match(/(\d+(?:[.,]\d+)?)\s*zł/gi) || [];
            matches.forEach(function (chunk) {
                var m = chunk.match(/(\d+(?:[.,]\d+)?)/);
                if (!m) return;
                var value = parseFloat(m[1].replace(',', '.'));
                if (!isNaN(value) && value > 0) best = value;
            });
        });
        return best;
    }

    function applyLinearProgressFill(barEl) {
        if (applyingLinearFill) return;
        var bar =
            barEl ||
            document.querySelector(
                '#rebuy-cart [data-rebuy-component="progress-bar"], #rebuy-cart .rebuy-cart__progress-bar-container, [data-rebuy-component="progress-bar"]'
            );
        if (!bar) return;
        var fill = bar.querySelector('.rebuy-cart__progress-bar-meter-fill');
        if (!fill) return;

        var tiers = parseTierMinimums(bar);
        var maxTier = tiers.length ? tiers[tiers.length - 1] : DEFAULT_MAX_TIER;
        if (!maxTier || maxTier <= 0) maxTier = DEFAULT_MAX_TIER;

        var subtotal = progressSubtotal;
        if (typeof subtotal !== 'number' || subtotal < 0) {
            subtotal = readVisibleCartSubtotal();
        }
        if (typeof subtotal !== 'number' || subtotal < 0) return;

        var pct = Math.max(0, Math.min(100, (subtotal / maxTier) * 100));
        var width = (Math.round(pct * 10) / 10).toFixed(1).replace(/\.0$/, '') + '%';
        var already =
            fill.getAttribute('data-kk-linear-fill') === width &&
            fill.style.getPropertyPriority('width') === 'important' &&
            fill.style.getPropertyValue('width') === width;
        if (already) return;

        applyingLinearFill = true;
        try {
            fill.style.setProperty('width', width, 'important');
            fill.setAttribute('aria-valuenow', String(Math.round(pct)));
            fill.setAttribute('data-kk-linear-fill', width);
            fill.setAttribute('data-kk-linear-max', String(maxTier));
            fill.setAttribute('data-kk-linear-subtotal', String(subtotal));
        } finally {
            applyingLinearFill = false;
        }
    }

    function refreshProgressSubtotal(thenApply) {
        fetch('/cart.js', { credentials: 'same-origin' })
            .then(function (r) {
                return r.json();
            })
            .then(function (cart) {
                // Prefer final payable subtotal (grosze → zł)
                var amount =
                    typeof cart.total_price === 'number'
                        ? cart.total_price / 100
                        : typeof cart.items_subtotal_price === 'number'
                          ? cart.items_subtotal_price / 100
                          : null;
                if (typeof amount === 'number') progressSubtotal = amount;
                if (thenApply !== false) applyLinearProgressFill();
            })
            .catch(function () {
                if (thenApply !== false) applyLinearProgressFill();
            });
    }

    function schedulePinProgressBar() {
        pinProgressBarToTop();
        refreshProgressSubtotal(true);
        setTimeout(pinProgressBarToTop, 100);
        setTimeout(function () {
            applyLinearProgressFill();
        }, 120);
        setTimeout(pinProgressBarToTop, 400);
        setTimeout(function () {
            applyLinearProgressFill();
        }, 450);
        setTimeout(pinProgressBarToTop, 1000);
        setTimeout(function () {
            refreshProgressSubtotal(true);
        }, 1100);
    }

    document.addEventListener('rebuy:smartcart.ready', schedulePinProgressBar);
    document.addEventListener('rebuy:smartcart.show', schedulePinProgressBar);
    document.addEventListener('rebuy:cart.change', function () {
        if (isSmartCartEnabled()) schedulePinProgressBar();
    });

    if (document.body) {
        var pinObs = new MutationObserver(function (mutations) {
            if (!isSmartCartEnabled()) return;
            if (!document.querySelector('#rebuy-cart.is-visible, .rebuy-cart.is-visible, .rebuy-cart-visible')) {
                return;
            }
            pinProgressBarToTop();
            // Rebuy/Vue often rewrites fill width — put linear value back
            for (var i = 0; i < mutations.length; i++) {
                var t = mutations[i].target;
                if (
                    t &&
                    t.classList &&
                    t.classList.contains('rebuy-cart__progress-bar-meter-fill') &&
                    !applyingLinearFill
                ) {
                    applyLinearProgressFill();
                    break;
                }
            }
        });
        pinObs.observe(document.body, {
            childList: true,
            subtree: true,
            attributes: true,
            attributeFilter: ['style', 'aria-valuenow']
        });
    }
    setTimeout(schedulePinProgressBar, 1500);
    setTimeout(schedulePinProgressBar, 3000);

    setTimeout(boot, 500);
    setTimeout(boot, 1500);
    setTimeout(boot, 3000);

    var hadSmartCart = isSmartCartEnabled();
    function observeBodyClass() {
        if (!document.body) return;
        var obs = new MutationObserver(function () {
            var enabled = isSmartCartEnabled();
            if (enabled && !hadSmartCart) {
                patchCartSidebarShow();
                scheduleUnlock();
            }
            // If theme re-adds sidebar-opened while Smart Cart is on, unlock again
            if (
                enabled &&
                (document.body.classList.contains('sidebar-opened') ||
                    document.body.classList.contains('sidebar-opened--right') ||
                    document.body.classList.contains('sidebar-opened--left'))
            ) {
                scheduleUnlock();
            }
            hadSmartCart = enabled;
        });
        obs.observe(document.body, { attributes: true, attributeFilter: ['class'] });
    }

    if (document.body) {
        observeBodyClass();
    } else {
        document.addEventListener('DOMContentLoaded', observeBodyClass);
    }
})();
